import ChatDate from "../../../chat-date";
import { BOT_CONV_MESSAGE_TYPE } from '../../../../consts/common-consts';
import { bubbleClass } from '../bubble-style';

/**
 * A payload with no dedicated renderer, shown as formatted JSON so an operator
 * can still read what the bot sent.
 */
export default function CustomMessage({senderType, message, date}) {
  const isBot = senderType === BOT_CONV_MESSAGE_TYPE;

  return (
    <div className={bubbleClass(isBot)}>
      <span className='text-[10px] font-semibold uppercase tracking-wide text-amber-600'>
        Custom message
      </span>
      {/* Was a <pre> nested inside a <p>, which is invalid and got re-parented
          by the browser. Scrolls in place rather than widening the bubble. */}
      <pre className='max-h-48 overflow-auto rounded bg-gray-50 p-2 text-[11px] leading-relaxed text-gray-800 ring-1 ring-inset ring-gray-200'>
        {JSON.stringify(message, null, 2)}
      </pre>
      <ChatDate date={date} isBot={isBot} />
    </div>
  );
}
